import script from "./TheHome.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHome.vue?vue&type=script&setup=true&lang=js"

import "./TheHome.vue?vue&type=style&index=0&id=62c648e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c648e0"]])

export default __exports__